import { Paper, Typography, Button, TextField, FormControl, Select, MenuItem, InputLabel, Dialog} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { updatetourrates, duplicatetrips,searchupdatedTripsbyDate, searchboTripsbyDate,fetchReftrips, fetchTripsbyStatus, fetchEmployees, fetchActiveTrips, fetchworkdoneleads, startcron, stopcron, imgupload,imgdelete, fetchquotetoday, leadassignment, fetchcancflagbydate, cancflag, searchQCbyDate, cronreport, report12pm, fupcount, quotepdf, fetchtestfunction, threedayprojection, fivedayprojection, currentfupcount, fixdupcust, aiquery, fetchLeadsbydateandproj} from "../api/customerapi";
import { useEffect, useState } from "react";
import DateCalc, { groupBy } from "./date";
import {url} from "../api/customerapi";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
     smallbutton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    height: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
    modalText: {
      marginLeft: theme.spacing(30),
      marginRight: theme.spacing(4),
      width: theme.spacing(120),
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(2),
      alignItems: 'center',
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
      textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "left",
      },
      textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  }));

const BulkWA=() => {

    const classes = useStyles();
    const [emp, setemp]=useState([])
    const [image, setimage]=useState("")
    const [name, setname]=useState("")
    const [Open19, setOpen19]=useState(false)
    const [queryData, setqueryData]=useState(false)
    var { cuser, role } = GetRole();
    function removeDuplicates(arr) {
      return arr.filter((item, 
          index) => arr.indexOf(item) === index);
  }

  useEffect(() => {
   
    getEmployees()
    
  }, []);

  const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //const custdatalistfromdb= data.data

    const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
    const empshortname = empsplist.map((emp) => emp.short_name);
    setemp(empshortname);
  }catch(err){
    console.log(err)
  }
  };  

  const fupfinalDate = DateCalc(0);
    const loaddata=async()=>{
      try{
      let startdate=prompt("Enter start date (YYYY-MM-DD):")
      let enddate=prompt("Enter end date (YYYY-MM-DD):")
      // var startdate="2023-02-19"
      // var enddate="2023-02-20"
      
    
      var finarr4=[]
      var finarr5=[]
      var finarr6=[]
      var finarr8=[]
      const data=await searchupdatedTripsbyDate(startdate, enddate)
      const finarr=data.data.filter(trip=>trip.trip_status !=="Hot" && trip.trip_status !=="Converted")
      
      
     for(let j=0;j<emp.length;j++) {
        const finarr2=finarr.filter(trip=>trip.trip_owner==emp[j])
        const finarr3=finarr2.sort((a,b)=>new Date(a.updatedAt).getTime()-new Date(b.updatedAt).getTime())
        
        for(let i=0; i<finarr3.length-1;i++){
          if(((new Date(finarr3[i+1].updatedAt).getTime()-new Date(finarr3[i].updatedAt).getTime())/(30*1000))<1){
            finarr4.push(finarr3[i])
            finarr5.push(finarr3[i+1])
          }
        }
        // if(emp[j]=="Sidharth"){
        //   console.log(finarr4)
        //   console.log(finarr5)
        // }
        
        
     }
     for(let i=0; i<finarr5.length-1;i++){
      if(("follow_up" in finarr5[i]) && ("notes" in finarr5[i].follow_up[finarr5[i].follow_up.length-1])){
      if((finarr5[i].follow_up[finarr5[i].follow_up.length-1].notes=="Call not picked") ||
      (finarr5[i].follow_up[finarr5[i].follow_up.length-1].notes=="Call not picked. WA sent") ||
      (finarr5[i].follow_up[finarr5[i].follow_up.length-1].notes=="Call not picked and no response on Whatsapp") ||
      (finarr5[i].follow_up[finarr5[i].follow_up.length-1].notes=="Asked to call later") ||
      (finarr5[i].follow_up[finarr5[i].follow_up.length-1].notes=="Asked to call later after a few days")
      ){
        finarr6.push(finarr5[i])
        finarr8.push(finarr4[i])
      }
    }
  }
  console.log(finarr6)
  console.log(finarr8)
  var finarr7 = finarr6.map(function(i) {
    return i.trip_id;
  });  
      
   alert(finarr7.toString())   
  }catch(err){
    console.log(err)
  }
     
    }

    const loadeditdata=async()=>{
      try{
      let startdate=prompt("Enter start date (YYYY-MM-DD):")
      let enddate=prompt("Enter end date (YYYY-MM-DD):")
      // var startdate="2023-03-18"
      // var enddate="2023-03-19"
      
    
      var finarr4=[]
      var finarr5=[]
      var finarr6=[]
      var finarr8=[]
      const data=await searchupdatedTripsbyDate(startdate, enddate)
      
     for(let i=0; i<data.data.length;i++){
      if(("follow_up" in data.data[i]) && ("notes" in data.data[i].follow_up[data.data[i].follow_up.length-1]) && data.data[i].follow_up[data.data[i].follow_up.length-1].notes){
      if((new Date(data.data[i].follow_up[data.data[i].follow_up.length-1].createdAt)>new Date(fupfinalDate) && data.data[i].follow_up[data.data[i].follow_up.length-1].notes=="Needed changes. Shared updated quote") 
      ){
        finarr6.push(data.data[i])
        //finarr8.push(finarr4[i])
      }
      if(("follow_up" in data.data[i]) && (data.data[i].follow_up.length>1) && ("notes" in data.data[i].follow_up[data.data[i].follow_up.length-2]) && data.data[i].follow_up[data.data[i].follow_up.length-2].notes){
        if((new Date(data.data[i].follow_up[data.data[i].follow_up.length-2].createdAt)>new Date(fupfinalDate) && data.data[i].follow_up[data.data[i].follow_up.length-2].notes=="Needed changes. Shared updated quote") 
        ){
          finarr6.push(data.data[i])
          //finarr8.push(finarr4[i])
        }
      }
      // if(!data.data[i].follow_up[data.data[i].follow_up.length-1].notes){
      //   console.log(data.data[i])
      // }
      //&& new Date(data.data[i].follow_up[data.data[i].follow_up.length-2].createdAt)>new Date(fupfinalDate)
    }
    
  }
  
  
  var finarr7 = finarr6.map(function(i) {
    return i.trip_id;
  });  

  //console.log(finarr7)
      
   var data2=await fetchquotetoday()   
   var finarr8 = data2.data.map(function(i) {
    return i.trip_id;
  });
  //console.log(finarr8)

  for(let i=0; i<finarr7.length; i++){
    if(!finarr8.includes(finarr7[i])){
      finarr4.push(finarr7[i]);
    }
  } 
  
  console.log(finarr4)

  alert(finarr4.toString())   
}catch(err){
  console.log(err)
}
    }

    const loadquotedata=async()=>{
      try{
      let startdate=prompt("Enter start date (YYYY-MM-DD):")
      let enddate=prompt("Enter end date (YYYY-MM-DD):")
      const data=await searchQCbyDate(startdate, enddate)
      //console.log(data.data.length)
      let sum=0
      for (let i=0; i<data.data.length; i++){
        // if(i==1){
        //   console.log(data.data[i])
        // }
        if(data.data[i].edit_count){
          sum=sum+data.data[i].edit_count
        }else{
          sum=sum+1
        }
        
        //console.log(sum)
      }
      alert(sum)
      
    
      }catch(err){
        console.log(err)
      }
    }
    

    const loadhot=async()=>{
      try{
      const data=await fetchTripsbyStatus("Hot")
      const f2 = data.data.filter(
        (tripdata) => 
          tripdata.follow_up.filter(
            (fup) => fup.date <= fupfinalDate && fup.status == "Open" && fup.time !=="17:30" && fup.time !=="17:00" && fup.time !=="13:30"
          ).length > 0
      );
    //console.log(f2)
      const finarr=[]
      const finarr2=[]
      for(let i=0; i<emp.length; i++){
        var tempobj={
          name:emp[i],
          pending:0
        }
        const list=f2.filter(trip=>trip.trip_owner==emp[i])
        if(list.length>0){
        const list2=list.map(({trip_owner, trip_id}) => ({trip_owner, trip_id}))
        tempobj.pending=list2.length
        //list2.map(list => alert(JSON.stringify(list)))
        finarr2.push(tempobj)
        finarr.push(list2)
      }
    }
      console.log(finarr)
      alert(JSON.stringify(finarr2))
      
    }catch(err){
      console.log(err)
    }
    }

    const loadfup=async()=>{
      try{
      const data=await fetchActiveTrips()
      const f2 = data.data.filter(
        (tripdata) => 
          tripdata.follow_up.filter(
            (fup) => fup.date <= fupfinalDate && fup.status == "Open" && fup.time !=="17:30" && fup.time !=="17:00" && fup.time !=="13:30"
          ).length > 0
      );
    //console.log(f2)
      const finarr=[]
      for(let i=0; i<emp.length; i++){
        const list=f2.filter(trip=>trip.trip_owner==emp[i])
        var tempobj={
          name:emp[i],
          pending:0
        }
        if(list.length>0){
        const list2=list.map(({trip_owner, trip_id}) => ({trip_owner, trip_id}))
        tempobj.pending=list2.length
        finarr.push(tempobj)
      }
    }
      alert(JSON.stringify(finarr))
    }catch(err){
      console.log(err)
    }
      
    }

    const loadlead=async()=>{
      try{
      const data=await fetchworkdoneleads()
      const finarr=[]
      for (let i=0; i<emp.length;i++){
        const list=data.data.filter(lead=>lead.lead_owner==emp[i])
        console.log(list)
        const tempobj={
          name:emp[i],
          workdone:list.length,
        }
        finarr.push(tempobj)
      }
      alert(JSON.stringify(finarr))
    }catch(err){
      console.log(err)
    }
    }

    const loadrefdata=async()=>{
      try{
      let startdate=prompt("Enter your start date in yyyy-mm-dd format")
      let enddate=prompt("Enter your start date in yyyy-mm-dd format")
      const data=await fetchReftrips(startdate, enddate)
      //console.log(data.data)
      console.log(data.data.map(trip=>trip.trip_id))
    }catch(err){
      console.log(err)
    }
    }

    const loadcancflag=async()=>{
      try{
      let startdate=prompt("Enter your start date in yyyy-mm-dd format")
      let enddate=prompt("Enter your start date in yyyy-mm-dd format")
      const data=await fetchcancflagbydate(startdate, enddate)
      //console.log(data.data)
      var x=data.data.map(trip=>trip.trip_id)
      alert(x)
    }catch(err){
      console.log(err)
    }
    }

    const loadbodata=async()=>{
      try{
      let startdate=prompt("Enter your start date in yyyy-mm-dd format")
      let enddate=prompt("Enter your start date in yyyy-mm-dd format")
      const data=await searchboTripsbyDate(startdate, enddate)
      console.log(data.data.map(trip=>trip.trip_id))
    }catch(err){
      console.log(err)
    }
    }

    const sendmsg= async() => {
    //console.log("sending...")
    }

    const startcron1= async() => {
      try{
      const data=await startcron()
      console.log(data.data)
    }catch(err){
      console.log(err)
    }
      }

      const stopcron1= async() => {
        try{
        const data=await stopcron()
        console.log(data.data)
      }catch(err){
        console.log(err)
      }
        }

        const runcanc= async() => {
          try{
          const data=await cancflag()
          //console.log(data.data)
        }catch(err){
          console.log(err)
        }
          }

          const handleClose19=()=>{
            setOpen19(false)
          }

        const imageUpload= async(e) => {
          try{
          //console.log(e.target.files[0])
          setimage(e.target.files[0].name)
          const formdata=new FormData()
          formdata.append("myFile",e.target.files[0],e.target.files[0].name)
          const data=await imgupload(formdata)
          console.log(data.data)
          console.log(url+"/uploads/"+e.target.files[0].name)
        }catch(err){
          console.log(err)
        }
        }

    const deleteimage=async()=>{
      try{
      console.log(name)
      const data=await imgdelete(name)
      console.log(data.data)
    }catch(err){
      console.log(err)
    }
    }

    const downloadpdf=async()=>{
      try{
      console.log(url+"/uploads/"+name)
      // const data=await downloadfile(name)
      // console.log(data.data)
      const aTag=document.createElement("a")
      aTag.href=url+"/uploads/"+name
      aTag.setAttribute("target","_blank")
      aTag.setAttribute("download",name)
      document.body.appendChild(aTag)
      aTag.click()
      aTag.remove()
    }catch(err){
      console.log(err)
    }
    }

      const getquotepdf=async()=>{
      try{
      //const res  = await fetch('/api/pdf?url=' + encodeURIComponent("https://www.jetovacations.com/quote/684808dfb4b42c206315bcc6"));
      const res  = await quotepdf("200000")
  const blob = await res.blob();
  const url  = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = 'report.pdf';
  a.click();
  window.URL.revokeObjectURL(url);
    }catch(err){
      console.log(err)
    }
    }

    const leadassign=async()=>{
      try{
      const data=await leadassignment()
    }catch(err){
      console.log(err)
    }

    }

    const loadtourrates=async()=>{
      const data=await updatetourrates()
    }

    const runcron=async()=>{
      const data=await cronreport()
    }

    const run12pm=async()=>{
      const data=await report12pm()
    }

    const runtest=async()=>{
      const data=await fetchtestfunction()
      // const url = window.URL.createObjectURL(new Blob([data.data]));
      // const a = document.createElement('a');
      // a.href = url;
      // a.download = 'data.xlsx';
      // a.click();
      //window.URL.revokeObjectURL(url);
    }

    const run3day=async()=>{
      const data=await threedayprojection()
      console.log(data.data)
    }

     const run5day=async()=>{
      const data=await fivedayprojection()
      console.log(data.data)
    }

    const duptrips=async()=>{
      const data=await duplicatetrips()
      console.log(data.data)
    }

    const fup=async()=>{
      const data=await currentfupcount()
      console.log(data.data)
    }

    const fixdupcustid=async()=>{
      const data=await fixdupcust()
      console.log(data.data)
    }

    const query=async()=>{
      try{
        var value=4, effort=""
        if(queryData.claude_model=="claude-haiku-4-5"){
          value=4
          effort="low"
        }else if(queryData.claude_model=="claude-sonnet-5"){
          value=6
          effort="medium"
        }else if(queryData.claude_model=="claude-opus-5"){
          value=14
          effort="high"
        }
        var data={question: queryData.query, 
        collections:queryData.model, 
        //context:"", 
        model:queryData.claude_model, 
        //mode:"lookup",
        maxSteps:value, 
        effort:effort
        }
        const response=await aiquery(data)
        console.log((response.data))
        if(response.data.status=="success"){
          setqueryData({...queryData, answer:response.data.answer, cost: response.data.usage.estimated_cost_usd, token:response.data.usage.total_tokens})
        }else{
          setqueryData({...queryData, answer:"Query Failed", cost: response.data.usage.estimated_cost_usd, token:response.data.usage.total_tokens})
        }
        

      }catch(err){
        console.log(err)
      }
    }

    const runassignmatrix=async()=>{
      let startdate=prompt("Enter start date (YYYY-MM-DD):")
      let enddate=prompt("Enter end date (YYYY-MM-DD):")
      const fields=["lead_destination", "createdAt","assignedAt"]
      const data=await fetchLeadsbydateandproj(startdate, enddate, fields)
      //console.log(data.data)
      var m=groupBy(data.data, v=>v.lead_destination)
      console.log(m)
      var finarr=[]
      for (let [key, value] of m) {
      var temp={
        dest:key,
        avg_assign_time:(value.reduce((sum,a)=>{
          let gap=new Date(a.assignedAt).getTime()-new Date(a.createdAt).getTime()
          if(gap==0){
            return sum
          }else{
            return sum+gap
          }
        },0))/(value.length*1000*60*60)
      }
      finarr=[...finarr, temp]
      }
      console.log(finarr)
    }

    return (
        <Paper variant="outlined" className={classes.paper}>
        <div>
            <Dialog fullWidth maxWidth="xl" open={Open19} onClose={handleClose19}>
                        <FormControl
                        style={{
                          minWidth: 450,
                          marginTop: 16,
                          marginRight: 24,
                          marginLeft: 5,
                        }}
                      >
                        <InputLabel id="Model">Model</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          labelId="Model"
                          onChange={(e) =>
                            setqueryData({ ...queryData, model: e.target.value })
                          }
                        >
                          <MenuItem value={"tripModel"}>{"tripModel"}</MenuItem>
                          <MenuItem value={"leadModel"}>{"leadModel"}</MenuItem>
                          <MenuItem value={"custModel"}>{"custModel"}</MenuItem>
                          <MenuItem value={"quoteModel"}>{"quoteModel"}</MenuItem>
                          <MenuItem value={"tourModel"}>{"tourModel"}</MenuItem>
                          <MenuItem value={"hotelModel"}>{"hotelModel"}</MenuItem>
                        </Select>
                      </FormControl>
                        <FormControl
                        style={{
                          minWidth: 450,
                          marginTop: 16,
                          marginRight: 24,
                          marginLeft: 5,
                        }}
                      >
                        <InputLabel id="Claude">Claude Model</InputLabel>
                        <Select
                          displayEmpty
                          className={classes.textField}
                          labelId="CModel"
                          onChange={(e) =>
                            setqueryData({ ...queryData, claude_model: e.target.value })
                          }
                        >
                          <MenuItem value={"claude-haiku-4-5"}>{"claude-haiku-4-5"}</MenuItem>
                          <MenuItem value={"claude-sonnet-5"}>{"claude-sonnet-5"}</MenuItem>
                          <MenuItem value={"claude-opus-5"}>{"claude-opus-5"}</MenuItem>
                        </Select>
                      </FormControl>
                      <br></br>
                         <TextField
                                          variant="outlined"
                                         
                                          fullWidth
                                          required
                                          value={(queryData.query)}
                                          className={classes.textArea}
                                          InputLabelProps={{ shrink: true }}
                                          onChange={(e) =>
                            setqueryData({ ...queryData, query: e.target.value })
                          }
                                        />
                                        <br></br>
                      <Button
                      onClick={()=>query()}
                      variant="contained"
                      color="primary"
                      className={classes.smallbutton}
                    >
                      <h6>Run</h6>
                    </Button>
                    {queryData && "answer" in queryData?(<div><p>{queryData.answer}</p><br></br><br></br><p>{queryData.token +" used at total cost of "+queryData.cost+" USD"}</p></div>):("")}
                  </Dialog>
          <Button
            onClick={loaddata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get Suspense Data
          </Button>
          <Button
            onClick={loadcancflag}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get CF
          </Button>
          <Button
            onClick={loadeditdata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get Edit Data
          </Button>
          <Button
            onClick={loadhot}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get Hot Data
          </Button>
          <Button
            onClick={loadfup}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get Fup Data
          </Button>
          <Button
            onClick={loadlead}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get lead Data
          </Button>
          <Button
            onClick={loadbodata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get BO Data
          </Button>
          <Button
            onClick={loadrefdata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Get Ref Data
          </Button>
          <Button
            onClick={startcron1}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Start Cron
          </Button>
          <Button
            onClick={stopcron1}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Stop Cron
          </Button>
          <Button
            onClick={runcanc}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Canc Flag
          </Button>
          <Button
            onClick={fixdupcustid}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Fix Dup Cust
          </Button>
          <Button
            onClick={leadassign}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Assign Leads
          </Button> 
          <Button
            onClick={loadquotedata}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Quote edit count
          </Button> 
          {cuser=="Debayan"?(
            <div>
            <Button
            onClick={loadtourrates}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Update Tour Rates
          </Button> 
          <Button
            onClick={runcron}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
           Cron report
          </Button> 
          <Button
            onClick={runassignmatrix}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
           Lead Assign Matrix
          </Button> 
          <Button
            onClick={run12pm}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
           12pm report
          </Button> 
           <Button
            onClick={fupcount}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
           FUP Analysis
          </Button> 
          <Button
            onClick={getquotepdf}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          Quote PDF
          </Button> 
          <Button
            onClick={runtest}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          Test
          </Button> 
          <Button
            onClick={run3day}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          3 Day Proj
          </Button> 
           <Button
            onClick={run5day}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          5 Day Proj
          </Button>
            <Button
            onClick={fup}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          FUP count
          </Button>
          <Button
            onClick={duptrips}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
          Duplicate Trips
          </Button>
          <Button
            onClick={()=>setOpen19(true)}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            AI Query
          </Button>
          </div>
          ):("")}
          
          </div>
          <div>
          <br></br>
          <hr></hr>
          <p>For testing purpose, do not use buttons below:</p>
          <hr></hr>
          <label>Upload Profile:</label>
            <input type="file" name="myFile" onChange={imageUpload}/>
          </div>
          <Button variant="contained" color="secondary" onClick={downloadpdf}>Download</Button>
          <img src={url+"/uploads/"+image} height={300} width={300} alt="ImageText"></img>
          <br></br>
          <TextField variant="standard"  type="text" label="Enter name"  InputLabelProps={{ shrink: true }} value={name} className={classes.textField} onChange={(e)=> setname(e.target.value)}/>
          <Button variant="contained" color="secondary" onClick={deleteimage}>Delete</Button>
        </Paper>
    )
}

export default BulkWA;